import { isMobileAtom, isWideAtom } from "@/atoms/appAtoms.ts";
import { useAtom } from "jotai";
import { useEffect } from "react";

/** Below this, a browser window is a phone's screen. */
export const MOBILE_BREAKPOINT = 768;
const WIDE_BREAKPOINT = 1024;

// TODO: this should be useBreakpoint
export function useIsMobile() {
  const [isMobile, setIsMobile] = useAtom(isMobileAtom);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, [setIsMobile]);

  return !!isMobile;
}

/** Returns true when the viewport is wide enough to show the full calendar layout (≥ 1024px). */
export function useIsWide() {
  const [isWide, setIsWide] = useAtom(isWideAtom);

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${WIDE_BREAKPOINT}px)`);
    const onChange = () => {
      setIsWide(window.innerWidth >= WIDE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsWide(window.innerWidth >= WIDE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, [setIsWide]);

  return !!isWide;
}
